{"sampleData":"Sample product screen. Every figure here is made up for the demo — not Jelloducks' real customer counts or sales."}